import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "container card d-flex flex-column mt-5 mb-5",
  style: {"width":"80%"}
}
const _hoisted_2 = { class: "row d-flex justify-content-center g-0 mb-5 animate__animated animate__fadeIn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarComponent = _resolveComponent("NavbarComponent")!
  const _component_PokemonInfo = _resolveComponent("PokemonInfo")!
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_NavbarComponent),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (Object.keys(_ctx.pokemon).length !== 0)
          ? (_openBlock(), _createBlock(_component_PokemonInfo, {
              key: 0,
              pokemon: _ctx.pokemon
            }, null, 8, ["pokemon"]))
          : (_openBlock(), _createBlock(_component_SpinnerComponent, { key: 1 }))
      ])
    ]),
    _createVNode(_component_FooterComponent)
  ], 64))
}